"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _unsplashHelper = require("@eig-builder/core-utils/helpers/unsplash-helper");

var _searchField = _interopRequireDefault(require("../controls/search-field"));

var _infiniteGrid = _interopRequireDefault(require("../controls/infinite-grid"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _authorAvatar = _interopRequireDefault(require("../controls/author-avatar"));

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

require("./style/free-images.scss");

var _commonSearchTerms = _interopRequireDefault(require("../controls/common-search-terms"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _CropRotate = _interopRequireDefault(require("@material-ui/icons/CropRotate"));

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

var _imageLibraryContainer = require("../image-library-container");

var _controlQuery = require("@eig-builder/control-query");

var _config = require("../config");

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _recoil = require("recoil");

var _store = require("../store");

var _hooks = require("../hooks");

var _templateObject, _templateObject2;

var StyledIconButton = (0, _styledComponents["default"])(_compositionsButtonWithIcon["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: 35px !important;\n  padding: 0 10px !important;\n"])));
var StyledAuthorAvatar = (0, _styledComponents["default"])(_authorAvatar["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  a {\n    color: white;\n    font-weight: bold;\n  }\n"])));

var mapImages = function mapImages(image) {
  var thumbnailWidth = Number((image.width / 7).toFixed(0));
  var thumbnailHeight = Number((image.height / 7).toFixed(0));
  var imageProxyThumb = image.urls.small;
  var imageProxyOriginal = image.urls.regular;
  var urls = (0, _unsplashHelper.makeUrlsSizes)(undefined, imageProxyOriginal);
  return {
    thumbnail: imageProxyThumb,
    thumbnailWidth: thumbnailWidth,
    thumbnailHeight: thumbnailHeight,
    original: imageProxyOriginal,
    originalHeight: image.height,
    originalWidth: image.width,
    tags: [],
    caption: '',
    color: image.color,
    source: 'unsplash',
    urls: urls,
    user: image.user,
    description: image.description,
    downloadLocation: image.links.download_location
  };
};

var currentPage = 0;

var fetchFreeImages = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(key, params, page) {
    var query, type, nextPage, url, response, totalAmount, data, dataToJson;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = params.query, type = params.type;
            nextPage = page || 0;
            url = type === 'free-images' ? "".concat(_config.FETCH_IMAGES_ENDPOINT, "?query=").concat(query, "&page=").concat(nextPage, "&per_page=30&client_id=98823feb68c3cd3b6c9495406a9d76630c3ab384108542847d37f9278e66dd0e") : "".concat(_config.FETCH_AUTHORS_ENDPOINT, "/").concat(query, "/photos?page=").concat(nextPage, "&per_page=30&client_id=98823feb68c3cd3b6c9495406a9d76630c3ab384108542847d37f9278e66dd0e");
            _context.next = 5;
            return (0, _fetch["default"])(url, {
              method: 'GET',
              simpleCall: true
            });

          case 5:
            response = _context.sent;
            totalAmount = response.headers.get('x-total');
            _context.next = 9;
            return response;

          case 9:
            data = _context.sent;
            _context.next = 12;
            return data.json();

          case 12:
            dataToJson = _context.sent;
            dataToJson.total = totalAmount;

            if (!(dataToJson === null || dataToJson === void 0 ? void 0 : dataToJson.results)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", dataToJson);

          case 16:
            return _context.abrupt("return", {
              results: dataToJson
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFreeImages(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var FreeImages = function FreeImages(_ref2) {
  var setActionTop = _ref2.setActionTop,
      preSearchQuery = _ref2.preSearchQuery,
      showModal = _ref2.showModal,
      onSelectionChanged = _ref2.onSelectionChanged,
      navigate = _ref2.navigate;

  var _useSearchQuery = (0, _hooks.useSearchQuery)(),
      search = _useSearchQuery.search;

  var _useActiveView = (0, _hooks.useActiveView)('free-images'),
      active = _useActiveView.active;

  var getInitialValueToSearch = function getInitialValueToSearch() {
    if (search.query) {
      return search.query;
    } else {
      if (preSearchQuery) {
        return preSearchQuery;
      } else {
        return _imageLibraryContainer.INITIAL_SEARCH_QUERY;
      }
    }
  };

  var _useRecoilState = (0, _recoil.useRecoilState)(_store.loadingState),
      _useRecoilState2 = (0, _slicedToArray2["default"])(_useRecoilState, 1),
      loading = _useRecoilState2[0].loading;

  var _React$useState = _react["default"].useState([search.type, {
    query: getInitialValueToSearch(),
    type: search.type
  }]),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      currentQuery = _React$useState2[0],
      setCurrentQuery = _React$useState2[1];

  var queryCache = (0, _controlQuery.useQueryCache)();
  var queryData = queryCache.getQueryData(currentQuery);

  var _useInfiniteQuery = (0, _controlQuery.useInfiniteQuery)(currentQuery, fetchFreeImages, {
    refetchOnWindowFocus: false,
    initialData: queryData,
    getFetchMore: function getFetchMore(lastGroups, allGroups) {
      if (lastGroups && lastGroups.results && lastGroups.results.length === 0) {
        return null;
      }

      currentPage = currentPage + 1;
      return currentPage;
    }
  }),
      images = _useInfiniteQuery.data,
      fetchMore = _useInfiniteQuery.fetchMore,
      canFetchMore = _useInfiniteQuery.canFetchMore,
      isFetching = _useInfiniteQuery.isFetching;

  _react["default"].useEffect(function () {
    if (!search.query) {
      setCurrentQuery([search.type, {
        query: getInitialValueToSearch(),
        type: 'free-images'
      }]);
    }

    if (search.query) {
      currentPage = 0;
      setCurrentQuery([search.type, search]);
    }
  }, [search.query]);

  var showDetailsModal = function showDetailsModal(index) {
    var imagesToShow = images.map(function (data) {
      return data.results;
    }).flat().map(mapImages);
    var meta = {
      images: imagesToShow,
      selectedImage: index,
      returnPage: 'free-images'
    };
    navigate(null, 'slideshow', meta);
  };

  var onImageSelect = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(index) {
      var imagesToShow;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              imagesToShow = images.map(function (data) {
                return data.results;
              }).flat().map(mapImages)[index];
              onSelectionChanged(imagesToShow, 'free-images');

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onImageSelect(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  if (!active) return null;
  var imageOptions = [{
    icon: /*#__PURE__*/_react["default"].createElement(_CropRotate["default"], {
      fontSize: "small"
    }),
    onClick: onImageSelect,
    tooltip: 'Edit'
  }];
  var dataToDisplay = (images || []).map(function (data) {
    return data === null || data === void 0 ? void 0 : data.results;
  }).flat().map(mapImages).map(function (photo, index) {
    var editImage = function editImage() {
      return onImageSelect(index);
    };

    return {
      onClick: function onClick() {
        return showDetailsModal(index);
      },
      src: photo === null || photo === void 0 ? void 0 : photo.thumbnail,
      width: photo === null || photo === void 0 ? void 0 : photo.originalWidth,
      height: photo === null || photo === void 0 ? void 0 : photo.originalHeight,
      backgroundColor: photo.color,
      key: "".concat(index),
      actions: {
        topRight: imageOptions.map(function (option, index) {
          var onClickWithIndex = function onClickWithIndex(e) {
            e.stopPropagation();
            editImage();
          };

          return /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
            key: "icon",
            size: "medium",
            color: "secondary",
            onClick: onClickWithIndex,
            icon: option.icon,
            labelPosition: "after",
            tag: "story-book-btn",
            dataElementLabel: "image-selector--image-grid--".concat(option.icon),
            dataElementLocation: _taggingHelper.DataElementLocations.BODY,
            dataElementId: "image-selector--image-grid--".concat(option.icon)
          }, option.tooltip);
        }),
        bottomLeft: [/*#__PURE__*/_react["default"].createElement(StyledAuthorAvatar, {
          key: "author-box",
          user: photo.user,
          viewMore: false,
          showTitle: false,
          invertColors: true,
          linkToUnsplash: true,
          nameDisplay: function nameDisplay(_ref4) {
            var name = _ref4.name;
            return name;
          }
        })]
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view free-images"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view-header ".concat((0, _mobileDetectionHelper["default"])() && 'mobile')
  }, /*#__PURE__*/_react["default"].createElement(_commonSearchTerms["default"], null), /*#__PURE__*/_react["default"].createElement(_searchField["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view-content"
  }, Array.isArray(dataToDisplay) && dataToDisplay.length === 0 && !loading && !isFetching && /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-search-results"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.noImagesFound"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "images"
  }, Array.isArray(images) && /*#__PURE__*/_react["default"].createElement(_infiniteGrid["default"], {
    data: dataToDisplay,
    loading: isFetching,
    loadMore: fetchMore,
    more: canFetchMore
  })))));
};

FreeImages.propTypes = {
  onSelectionChanged: _propTypes["default"].func,
  preSearchQuery: _propTypes["default"].string,
  setActionTop: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].func,
  navigate: _propTypes["default"].func
};

var _default = (0, _withContext["default"])(FreeImages);

exports["default"] = _default;